import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getPackageDetailData(trackingId, nodeId) {

    const requestParams = {
        "trackingId": [trackingId],
        "nodeId": [nodeId]
    }

    const request = {
        resourcePath: "/os/getPackageDetailData",
        httpMethod: "get",
        processName: "oculus",
        requestParams: requestParams
    }

    const startTime = Date.now();

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageDetailData", true);
            return response.data;
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageDetailData", false);
            if (typeof response.errorResponse !== 'undefined' && response.errorResponse.statusCode === "403") {
                throw (response.errorResponse);
            }
            return null;
        }
    } catch (error) {
        throw error
    }

}

export function getMockPackageDetailDataForGMDPkg() {
    return {packageDetail: {packageData: {}}};
}


// WEBPACK FOOTER //
// ./src/commons/api/GetPackageDetailsResults.js